import { render, staticRenderFns } from "./ActiveIssues.vue?vue&type=template&id=b0a2bad2&"
import script from "./ActiveIssues.vue?vue&type=script&lang=js&"
export * from "./ActiveIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports